<script setup lang="ts">
import type { DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import type { EventModel } from '@/types/models/EventModel'
import { DebouncedNumberInputField } from '@rfc/rfc-components-library'
import { useDebounceFn } from '@vueuse/core'
import DetectionsFilters from '../DetectionsFilters.vue'

type Props = {
    filters: DetectionFilters
    selectedEvent?: Partial<EventModel>
}
defineProps<Props>()

type Emits = {
    (e: 'change', value: Partial<DetectionModel>): void
    (e: 'selectEvent', value?: EventModel): void
}
const emit = defineEmits<Emits>()

const handleTyping = (value: Record<string, string | number | undefined>) =>
    value ? debouncedValue(value) : emit('change', value)

const debouncedValue = useDebounceFn(
    (value: Record<string, string | number | undefined>) => emit('change', value),
    1000
)

const onWheel = () => {}

const handleMinValue = (key: string, value: number | undefined, min: number) =>
    handleTyping({ [key]: (value ?? 0) < min ? undefined : value })
</script>

<template>
    <DetectionsFilters :filters="filters" @change="$emit('change', $event)">
        <DebouncedNumberInputField
            :label="$t('detection.filters.eventId')"
            :modelValue="filters.event_filter"
            @change="
                $event
                    ? handleMinValue('event_filter', $event, 1)
                    : $emit('change', { event_filter: undefined })
            "
            :prefix="$t('unit.number')"
            :min="1"
            editMode
            @wheel="onWheel" />
        <DebouncedNumberInputField
            :label="$t('detection.filters.timerId')"
            :modelValue="filters.timer_filter"
            :prefix="$t('unit.number')"
            :min="1"
            @change="
                $event
                    ? handleMinValue('timer_filter', $event, 1)
                    : $emit('change', { timer_filter: undefined })
            "
            editMode
            @wheel="onWheel" />
    </DetectionsFilters>
</template>
